import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQueryList = window.matchMedia(query);

    // Debounce callback to avoid rapid state changes
    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    const updateMatch = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setMatches(mediaQueryList.matches);
      }, 100); // 100ms debounce
    };

    updateMatch(); // initialize on mount

    mediaQueryList.addEventListener('change', updateMatch);
    return () => {
      mediaQueryList.removeEventListener('change', updateMatch);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [query]);

  return matches;
}
